import useInstantPayEnabled from '@/enterprise/components/InstantPay/useInstantPayEnabled';
import { useInvoiceCentralLayoutContext } from '@/enterprise/components/InvoiceCentral/InvoiceCentralLayout';
import { hasInstantPayAllowedDivision, SubstitutionsView } from '@/enterprise/features/invoiceTables/substitutions';
import useDataDog from '@/reporting/DataDog';
import NavigateWithRedirect from '@/shared/components/NavigateWithRedirect';
import { asEnterpriseLink } from '@/utils/experienceLinkHelper';

/**
 * Invoice Central substitutions tab — thin host over the Instant Pay substituted-invoice view.
 * Bookmarked URLs fall back to the Eligible tab when Instant Pay is off or no division of the
 * buyer is fully set up for Instant Pay.
 */
const Substitutions = () => {
  const { addAction } = useDataDog();
  const isInstantPayEnabled = useInstantPayEnabled();
  const {
    buyer,
    urlParams: { makerOrganizationUuid, currency },
  } = useInvoiceCentralLayoutContext();

  if (!isInstantPayEnabled || !hasInstantPayAllowedDivision(buyer.takerMarkets)) {
    return (
      <NavigateWithRedirect to={asEnterpriseLink(`invoice-central/${makerOrganizationUuid}/${currency}/eligible`)} />
    );
  }

  return (
    <SubstitutionsView
      source={{
        makerOrganizationUuid,
        currency,
        takerMarkets: buyer.takerMarkets,
      }}
      actions={{
        onSearch: () => {
          addAction('invoice-central::invoices-searched', {
            invoiceType: 'substitution',
            makerOrganizationUuid,
            currency,
          });
        },
      }}
    />
  );
};

export default Substitutions;
